import { render } from "./elem-label.vue?vue&type=template&id=bfbe48c2&ts=true"
import script from "./elem-label.vue?vue&type=script&lang=ts"
export * from "./elem-label.vue?vue&type=script&lang=ts"

import "./elem-label.vue?vue&type=style&index=0&id=bfbe48c2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__